// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-box-providers {
    text-align: left;
    box-shadow: 0px 0px 4px #e7e7e7;
    /* min-height: 135px; */
    border: 1px solid #e5e5e5;
    padding: 10px;
}

.button-box-providers ul span{
    min-width: 75px;
    display: inline-block;
}
.button-box-providers ul li{
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/serviceproviders/ServiceProviders.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB","sourcesContent":[".button-box-providers {\r\n    text-align: left;\r\n    box-shadow: 0px 0px 4px #e7e7e7;\r\n    /* min-height: 135px; */\r\n    border: 1px solid #e5e5e5;\r\n    padding: 10px;\r\n}\r\n\r\n.button-box-providers ul span{\r\n    min-width: 75px;\r\n    display: inline-block;\r\n}\r\n.button-box-providers ul li{\r\n    display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
